import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-crudo px-5 py-14 text-noche sm:px-8 lg:py-18" data-id="element-33" data-mp="1gj3pw36yxnup">
      <div className="mx-auto max-w-3xl" data-id="element-34" data-mp="2496ajy8jzrja">
        <motion.h2 initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.4,
        ease: EASE
      }} className="font-display text-2xl font-black uppercase leading-tight sm:text-3xl" data-id="element-35" data-mp="24a94yg534c3y">
          ¿Tenés alguna duda?
        </motion.h2>

        <div className="mt-7 divide-y divide-noche/10 border-y border-noche/10" data-id="element-36" data-mp="2n8bxh4wucr6i">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.q} data-id="element-37" data-mp="14vabtxsn8x2d" data-mpi={index}>
                <h3 data-id="element-38" data-mp="14wbxsxb773yv">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 py-4 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-electrico" data-id="element-39" data-mp="14vtrf7utn9d8">
                    <span className="font-display text-sm font-extrabold uppercase tracking-wide sm:text-base" data-id="element-40" data-mp="1ohq379699d1s">
                      {faq.q}
                    </span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-electrico transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-41" data-mp="1xk7rdt5h0frf" />
                  </button>
                </h3>

                <AnimatePresence initial={false} data-id="element-42" data-mp="3ue2jggqavoa7">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: EASE
              }} className="overflow-hidden" data-id="element-43" data-mp="1yaekmeb6220e">
                      <p className="pb-4 pr-8 text-sm leading-relaxed text-noche/65" data-id="element-44" data-mp="2h7z0wwzv7s9e">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}